import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import Swal from 'sweetalert2';
import { SpanButton } from 'component/button_components/button.style';
import { deleteUserData } from 'redux/slices/userSlice';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { ReactComponent as DeleteIcon } from 'assets/images/SVG/icons/delete-icon.svg';
import { useRefreshUserTab } from 'component/table_component/users_data/refreshUserData';
import { refreshToken } from 'redux/slices/authSlice';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';

export default function DeleteModal({ ...record }) {
  const dispatch = useDispatch();
  const refreshUserTab = useRefreshUserTab();
  const [loader, setLoader] = useState(false);
  const selectedNode = useSelector((state) => state.selectedNode);

  const showSweetAlert = async () => {
    await dispatch(refreshToken());
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Are you sure you want to delete?',
      showConfirmButton: true,
      confirmButtonColor: 'var(--bg-button-default-color)',
      width: '400px',
      heightAuto: false,
      showCancelButton: true,
      cancelButtonColor: 'green',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        container: 'custom-swal-container',
        icon: 'custom-swal-icon',
        title: 'custom-swal-title',
      },
    });

    if (result.isConfirmed) {
      try {
        setLoader(true);
        let values = {
          fqdn: selectedNode.domainName,
          dn: [record.dn],
        };
        const sweetAlert = await dispatch(deleteUserData(values));
        if (sweetAlert.payload && sweetAlert.payload.status === 200) {
          await SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
        } else {
          await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        }
      } catch (error) {
        await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      } finally {
        setLoader(false);
        await refreshUserTab();
      }
    }
  };

  return (
    <>
      {loader && <ModalOpenLoader />}
      <Tooltip title='Delete' color='#597081' className='af-user-delete-tooltip'>
        <SpanButton onClick={showSweetAlert} className='hover-icon af-user-delete-tooltip-button'>
          <DeleteIcon className='af-user-delete-tooltip-icon' />
        </SpanButton>
      </Tooltip>
    </>
  );
}
